import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { tomos } from '../data/content';
import { Reveal } from './Reveal';
export function Tomos() {
  return <section className="bg-cream py-20 sm:py-28" id="contenido" aria-labelledby="tomos-title" data-id="element-217" data-mp="139uzqlnl4jb9">
      <div className="mx-auto max-w-6xl px-6" data-id="element-218" data-mp="1h4xd1turhay3">
        <Reveal className="max-w-3xl" data-id="element-219" data-mp="1cbb9qsahmjey">
          <p className="inline-flex items-center gap-2 rounded-full bg-sand px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-cream-line" data-id="element-220" data-mp="1ca9ltn8di2ft">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="1m149mw19pa3d" />
            Lo que recibes
          </p>
          <h2 id="tomos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-222" data-mp="200ngllicefe3">
            3 tomos: de la receta al pedido cobrado
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-223" data-mp="5oyy59cwjuoy">
            Primero las recetas, luego los menús armados con esas recetas y al final el plan para venderlos. Cada tomo usa los mismos códigos y los mismos números.
          </p>
        </Reveal>

        <ol className="mt-12 grid gap-px overflow-hidden rounded-3xl bg-cream-line md:grid-cols-3" data-id="element-224" data-mp="34oviclmt7ddf">
          {tomos.map((tomo, index) => <li key={tomo.number} className="flex" data-id="element-225" data-mp="3eoe1x0yt4x4y" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col bg-sand p-7" data-id="element-226" data-mp="3enl3qodwzfyf">
                <span className="font-display text-4xl leading-none text-terra" data-id="element-227" data-mp="3jgxfvz1epuaa">
                  {String(tomo.number).padStart(2, '0')}
                </span>
                <h3 className="mt-5 font-display text-xl text-ink" data-id="element-228" data-mp="3sfj4obxh25ji">
                  {tomo.title}
                </h3>
                {tomo.subtitle ? <p className="mt-1 text-sm font-medium uppercase tracking-wide text-mint-700" data-id="element-229" data-mp="1asrxno6nrhl">
                    {tomo.subtitle}
                  </p> : null}
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-230" data-mp="2325z6jdmibgt">
                  {tomo.description}
                </p>
                <ul className="mt-5 space-y-2.5" data-id="element-231" data-mp="280plikw4pp9p">
                  {tomo.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-232" data-mp="200j8qy3u43dl">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-700" aria-hidden="true" data-id="element-233" data-mp="1vyo6nre2xlyr" />
                      <span className="text-sm leading-relaxed text-ink-soft" data-id="element-234" data-mp="29y7fkmept1c4">{point}</span>
                    </li>)}
                </ul>
              </Reveal>
            </li>)}
        </ol>

      </div>
    </section>;
}